"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Send = function Send(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Send"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "send copy 3"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "send"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0 18.57 20 10 0 1.43 0 8.1 13.5 10 0 11.9 0 18.57"
  })));
};

var _default = Send;
exports["default"] = _default;